export default function (number: string, message: string){
    const API_URL = 'https://api.whatsapp.com/send?phone=';
    return API_URL + number + '&text=' + message;
}